import React from "react";
import { firestore } from '../firebase.js';
import ViewMyJobsCard from './ViewMyJobsCard';
import '../Styles/Sass/ViewMyJobs.scss';

function ViewMyJobs(props) {
  const [userJobs, setUserJobs] = React.useState([]);
  const [isCleaner, setIsCleaner] = React.useState(true);

  React.useEffect(() => {
    getJobs();
  }, []);

  const getJobs = () => {
    if (props.user) {
      firestore.collection('users').doc(props.user.uid).get()
        .then(res => {
          let jobs = res.data().jobs;
          setUserJobs(jobs);
          let userStatus = res.data().job;
          if (userStatus !== 'cleaner') {
            setIsCleaner(false);
          }
        })
        .catch(err => {
          console.log(err);
        })
    }
  };

  const renderMyJobs = () => {
    let renderedJobs = userJobs.map(job => {
      if (job.status !== 'posted'){
        return (
          <ViewMyJobsCard
            jobId={job.jobId}
            status={job.status}
          />
        );
      } else {
        return (
          <>
          </>
        )
      }
    });
    return renderedJobs;
  }

  return(
    <section className='viewMyJobs'>
      {
        isCleaner === true ?
        <>
          <h3>My Jobs</h3>
          <ul>
            {renderMyJobs()}
          </ul>
        </> :
        <></>
      }
    </section>
  );
}

export default ViewMyJobs;